<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery :pageSize="pageSize" :isReports="reportPage" :currentPage="currentPage" :searchName="searchName"
        ref="search" class="search-content" @getBaseId="getProBaseId">
        <el-button type="primary" icon="el-icon-search" size="small" style="margin-left:15px" @click="getSearch">
          {{ $t('message.button.ProductDataQuery') }}
        </el-button>
        <el-button type="primary" icon="el-icon-zoom-in" size="small" style="margin-left:15px" v-show="isPro"
          @click="getSearchPerformance">
          {{ $t('message.title.projectScheduleReports') }}
        </el-button>
      </SearchQuery>
      <div style="height: 6px; background: #ebebeb"></div>
    </div>
    <div class="search_cotent">
      <el-card>

        <div v-loading="loading">

          <vxe-toolbar ref="xToolbar" custom print export>
            <template #buttons>
              <span> {{ getTotalMeg(totalRols) }} </span>
            </template>
            <!-- <div slot="tools">
              <div :class="{ xxx: !gridOptions.data.length }">
                <div @click="exportBOM" size="small" :class="{ xx: !gridOptions.data.length }" class="export-button"><i
                    class="el-icon-download icon"></i></div>
              </div>
            </div> -->
          </vxe-toolbar>

          <vxe-table border height="520" show-overflow align="center" class="mytable-style" resizable ref="table"
            :print-config="{}" :toolbar-config="tableToolbar" @custom="customEvent" :row-style="rowStyle"
            :data="gridOptions.data">

            <vxe-column>

              <template slot-scope="scope">
                <!-- <i :class="item.icon" :title="item.field" v-show="scope.row[item.field]"></i> -->
                <div class="flag">
                  <div v-for="i in 3" :key="i">
                    <i :class="getRowFlag(scope.row, i).icon" :title="getRowFlag(scope.row, i).title"></i>
                  </div>
                </div>
              </template>
            </vxe-column>
            <vxe-column v-for="item in gridOptions.columns" :title="item.title" :field="item.field" :key="item.index"
              minWidth="140"></vxe-column>
          </vxe-table>

          <!-- <el-pagination
            small
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRols"
          >
          </el-pagination> -->
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import TitleTag from "@/components/titleTag";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import axios from "axios";
import XEUtils from "xe-utils";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { baseInfo } from "../../utils/publicstate";
export default {
  name: 'classes',
  data() {
    return {
      searchName: "",
      buttonName: this.$t('message.title.ProductDataQuery'),
      checked: false,
      loading: false,
      tableShow: false,
      reportPage: true,

      pageSizes: [20, 50, 100, 200],
      pageSize: 20,
      currentPage: 1,
      searchBaseId: 0,

      totalRols: "",

      seekId: 0,

      ll: [
        "el-icon-news",
        "el-icon-data-line",
        "el-icon-office-building",
        "el-icon-paperclip",
      ],

      colorList: ["#13ce66", "#fcad2c", "#F56C6C", "#38A8F6"],
      iconType: [],

      TagList: [],

      tableToolbar: {
        buttons: [{ code: "myInsert", name: "", type: "text" }],
        print: true,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },
      isPro: false,
      rowStyle: { cursor: "pointer" },
      gridOptions: {
        id: '',
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 660,
        align: "left",
        highlightHoverRow: true,
        editConfig: { trigger: "dblclick", mode: "row" },
        columns: [],
        data: [],
        customConfig: { storage: true }
      },
    };
  },
  components: {
    SearchQuery,
    TitleTag,
  },
  mounted() {
    this.$store.commit('setIncludesList', 'classes');
  },
  methods: {


    getRowFlag(row, index) {
      // console.log(row);
      const arr = [{ title: '历史变更', icon: 'el-icon-data-line' }, { title: 'BOM', icon: 'el-icon-news' }, { title: '附件', icon: 'el-icon-document' }];
      const { hasRev = 0, isBOM = 0, isFile = 0 } = row.ObjectId;
      const list = [hasRev, isBOM, isFile];
      const e = index - 1;
      const t = list[e];
      // const icon = t ?  arr[e].icon : 'holder';
      let { title, icon } = arr[e]
      icon = t ? icon : 'holder'
      const str = t ? '有' : '无'
      return { icon, title: str + title }
    },

    customEvent({ type, $table }) {

      if (type != 'confirm') {
        return;
      }
      const currentColumns = $table.getColumns().map(i => i.property);
      const saveColumns = $table.tableFullColumn.filter(i => !currentColumns.includes(i.property)).map(i => i.property).join(';')
      let seekVo = { ...this.$refs.search.getSearchInfo().seekVo, saveColumns, isPublic: 9, name: Date.now() + '' }
      this.seekId && Object.assign(seekVo, { id: this.seekId });

      axios.post("/search/advanced/saveSeek", { seekVo })
        .then(res => {
          console.log(res);
          this.seekId = res.data.object.result.id;
        })
        .catch(_ => { })
    },

    exportBOM() {
      NProgress.start();
      // 对数据预处理
      const column = this.$refs.table.getColumns();
      const columnTitle = column.map((i) => i.title);
      const columnId = column.map((i) => i.property);
      let data = [];
      data.push(columnTitle);
      this.visiableData.map((i) => {
        let n = columnId.map((j, e) => {
          return e < 4 && i[j] ? '✔' : i[j]
        });
        // console.log(n);
        // n.map( =>)
        data.push(n);
      });
      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, this.buttonName + ".xlsx");
      NProgress.done();
    },
    getSearch() {
      const obj = this.$refs.search.getSearchInfo();
      console.log(obj);
      this.$refs.search.searchShow = false;
      this.searchBaseId = obj.seekVo.baseId;
      this.loading = true;

      var session = window.sessionStorage.getItem("userContext");
      session = JSON.parse(session);
      console.log(session);

      let idList = Object.values(obj.seekVo).join(';')
      this.gridOptions.id = idList + ';' + session.id;
      this.gridOptions.columns = [];
      this.gridOptions.data = [];
      this.tableToolbar.buttons[0].name = "";

      const url = baseInfo.find((i) => i.id == obj.seekVo.baseId).searchUrl;
      axios.post(url, obj).then((res) => {
        console.log(res);
        let columnlist = [],
          listData = [];
        if (obj.seekVo.baseId == 301) {
          if (res.data.object.result.length) {
            // const data = res.data.object.result.filter(i =>!i.rows[0].parentRowId)
            const data = res.data.object.result;
            // console.log(data);
            columnlist = data[0].columnInfo.names.map((i, e) => {
              return {
                title: i,
                field: parseInt(data[0].columnInfo.ids[e]),
                minWidth: "140",
              };
            });
            let tempData = data.map((i) => i.rows[0]);
            this.getSeq(this.getAllRows(tempData, columnlist)).map((i) => {
              // listData.push([]);
              listData.push(i);
            });
            // listData.shift()
            columnlist.unshift({ field: "sqe", title: "序号", minWidth: 75 });
            columnlist[1].treeNode = true;

            this.gridOptions.columns = columnlist;
            (this.gridOptions.treeConfig = {
              children: "children",
              expandAll: true,
            }),
              (this.gridOptions.data = listData);

            this.visiableData = this.getAllRow(listData);
            console.log(this.visiableData);
            this.gridOptions.stripe = false;
            let len = listData.filter((i) => !!i.objId);
            this.tableToolbar.buttons[0].name = this.getTotalMeg(len.length)
            this.tableShow = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableToolbar.buttons[0].name = this.getTotalMeg()
          }
        } else {
          if (res.data.code == 200) {
            const data = res.data.object;
            if (JSON.stringify(data) != "{}") {
              this.getItemData(data);
              this.setColumns();
            } else {
              this.loading = false;
              this.tableToolbar.buttons[0].name = this.getTotalMeg(0)
            }
          }
          else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        }
      });
    },
    formatTableData(val) {
      const { columnInfo, rows } = val;
      const { ids, names, columns } = columnInfo;
      const col = names.map((i, e) => ({ title: i, field: "props" + ids[e] }));
      const data = rows.map((i) => {
        const cell = i.cells;
        let obj = {};
        cell.map((j, e) => {
          const key = col[e].field;
          obj[key] = j?.val || "";
        });
        const {
          objId: id,
          objClass: classId,
          objSubClass: subClassId,
          hasRev,
          isBOM,
          isFile,
        } = i;
        obj.objectProperty = {
          id,
          classId,
          subClassId,
          hasRev,
          isBOM,
          isFile,
        };
        return obj;
      });
      return [col, data];
      // return classId.toString().substring(0, 3);
    },
    getItemData(tables) {

      const { totalRecords, seekId, saveColumns = '' } = tables["tableP1"];
      this.totalRols = totalRecords;
      this.seekId = seekId;
      this.seekColumns = saveColumns || [];

      // this.totalRols = tables["tableP1"]?.totalRecords;
      // this.seekId = tables["tableP1"]?.seekId;
      // this.seekColumns = tables["tableP1"]?.saveColumns ?? "";

      // console.log(tables);
      const arr = ['tableP1', 'tableP2', 'tableP3'].map(item => {
        return tables[item]
      }).filter(i => !!i).map(item => {
        const { columnInfo, rows } = item;
        return this.formatTableData({ columnInfo, rows })
      })

      let col = [], data = arr[0][1];
      arr.forEach((i, e) => {
        const [a, b] = i;
        col = [...col, ...a];
        if (data.length && !!e) {
          const n = data.map((j, x) => {
            const n = { ...j, ...b[x] }
            return n
          })
          data = n
        }
      })
      // console.log(data);
      const xxx = arr[0][1];
      data.forEach((i, e) => {
        i.ObjectId = xxx[e].objectProperty
      })

      this.gridOptions.columns = col;
      this.gridOptions.data = data;

      this.loading = false;
      return Promise

      // let columnlist = [];
      // this.TagList = [];
      // this.iconType = [];
      // this.seekId = data["tableP1"]?.seekId;
      // this.seekColumns = data["tableP1"]?.saveColumns ?? "";
      // let arr = Object.values(data).filter(i => i.tableID)
      // let dataRows = arr.map((item,) => {
      //   let tempRow = [];
      //   const n = item.columnInfo.names.map((i, e) => ({
      //     title: i,
      //     field: item.columnInfo.ids[e].toString(),
      //     minWidth: "140",
      //     sortable: true,
      //   }));
      //   columnlist = [...n, ...columnlist];
      //   item.rows.map((j) => tempRow.push(j.cells));
      //   return tempRow;
      // }).filter((i) => !!i.length);
      // console.log(dataRows);
      // // dataRows = dataRows.filter((i) => !!i.length);
      // let newArray = dataRows[0].map(function (col, i) {
      //   return dataRows.map(function (row) {
      //     return row[i];
      //   });
      // });
      // // console.log(newArray);
      // let tempArr = newArray.map((i) => {
      //   let arr = [];
      //   i.map((j) => {
      //     return (arr = [...j, ...arr]);
      //   });
      //   return arr;
      // });




      // let listData = tempArr.map((i) => {
      //   let temp = {};
      //   i.map((j, e) => {
      //     Object.assign(temp, { [columnlist[e].field]: j.val },);
      //   });
      //   return temp;
      // });

      // console.log(listData);


      // this.gridOptions.columns = [...columnlist];
      // console.log(columnlist);

      // this.gridOptions.data = listData;
      // this.visiableData = listData;
      // this.totalRols = listData.length;
      // this.tableToolbar.buttons[0].name = this.getTotalMeg(listData.length)
      // this.tableShow = true;
      // this.loading = false;

      // return Promise;
    },
    getTotalMeg(n) {
      return this.$t('message.title.totalResults') + n + this.$t('message.title.resultsNums');
    },
    setColumns() {
      console.log(this.$refs.table);
      this.$refs.table.getColumns().filter(i => this.seekColumns.includes(i.property)).map(i => {
        const column = this.$refs.table.getColumnByField(i);
        this.$refs.table.hideColumn(column);
      })
    },
    getSearchPerformance() {
      const obj = this.$refs.search.getSearchInfo();
      axios
        .post("/ppm/projectStatus/searchProjectTeamAndExportExcel", obj)
        .then((res) => {
          if (res.data.code == 200) {
            let columnlist = [],
              dataRows = [],
              listData = [];
            const data = res.data.object;
            if (JSON.stringify(data) != "{}") {
              const arr = Object.values(data);
              arr.map((item, index) => {
                let tempRow = [];
                const n = item.columnInfo.names.map((i, e) => {
                  return {
                    title: i,
                    field: item.columnInfo.ids[e].toString(),
                    minWidth: "140",
                  };
                });
                columnlist = [...n, ...columnlist];
                item.rows.map((j) => tempRow.push(j.cells));
                dataRows.push(tempRow);
              });
              // console.log(dataRows);
              dataRows = dataRows.filter((i) => !!i.length);
              let newArray = dataRows[0].map(function (col, i) {
                return dataRows.map(function (row) {
                  return row[i];
                });
              });
              // console.log(newArray);
              let tempArr = newArray.map((i) => {
                let arr = [];
                i.map((j) => {
                  return (arr = [...j, ...arr]);
                });
                return arr;
              });

              tempArr.map((i) => {
                let temp = {};
                i.map((j, e) => {
                  Object.assign(temp, { [columnlist[e].field]: j.val });
                });
                listData.push(temp);
              });

              this.gridOptions.columns = columnlist;
              this.gridOptions.data = Object.freeze(listData);
              this.visiableData = Object.freeze(listData);
              this.totalRols = listData.length;
              this.tableToolbar.buttons[0].name = this.getTotalMeg(listData.length)

              this.tableShow = true;
              this.loading = false;
            } else {
              this.loading = false;
              this.tableToolbar.buttons[0].name = this.getTotalMeg(0)
            }
          } else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        });
    },

    getProBaseId(e) {
      console.log(e);
      this.isPro = e.value == 301;
      this.buttonName = e.label;
    },

    getSeq(array, l, n) {
      if (!array || !array.length) return;
      let level = l || 1;
      let parentLevel = n || 0;
      array.forEach((item, e) => {
        item.sqe = !parentLevel ? e + 1 + "" : parentLevel + "." + (e + 1 + "");
        // if (level == 1) {
        //   item.sqe = '1'
        // }
        if (item.children && item.children.length) {
          this.getSeq(item.children, level + 1, item.sqe);
        }
      });
      return array;
    },

    getAllRows(arr, columns) {
      // console.log(arr);
      let newArr = [];
      // let L = isLeaf || false;
      arr.map((i, e) => {
        let n = this.getRow(i, columns);
        // console.log(n);
        newArr.push(n);
        if (i.children != null) {
          n.children = this.getAllRows(i.children, columns);
        } else {
          n.children = [];
        }
      });
      return newArr;
    },
    getRow(arr, columns) {
      let n = {};
      // console.log(this.gridOptions.columns);
      n.objId = arr.objId;
      columns.map((i, e) => {
        // console.log(arr);
        let val = arr.cells[e].val || "";
        if ([1051001, 1051002, 1051004, 1051005].includes(i.field)) {
          val = val.split("T")[0];
        }
        Object.assign(n, { [i.field]: val });
      });
      // console.log(n);
      return n;
    },
  },
};
</script>

<style scoped>
.flag {
  column-count: 3;
  column-gap: 10px;
  cursor: pointer;
}

.holder {
  width: 40px;
  height: 16px;
  /* background: #4b92ff; */
  display: block;
  /* border: 1px solid #fff; */
  /* border: #4b92ff 1px solid; */
}

.xx {
  pointer-events: none;
  /* color: tomato; */
}

.xxx {
  cursor: not-allowed;
}

.item {
  margin-right: 15px;
}

.proxx {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: white;
  display: inline-block;
  margin-right: 3px;
  /* border: crimson 1px solid; */
  /* background-color: #13ce66; */
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: white;
  display: inline-block;
  /* margin-right: 3px; */
  /* border: crimson 1px solid; */
  /* background-color: #13ce66; */
}

.export-button {
  margin-right: 12px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: block;
  border: 1px solid #dcdfe6;
  text-align: center;
  cursor: pointer;
}

.export-button .icon {
  height: 34px;
  line-height: 34px;
  font-size: 15px;

}

.export-button .icon:hover {
  color: #3ea0fb;
}

.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}
</style>
